import { render, staticRenderFns } from "./dragon-activity-statistics.vue?vue&type=template&id=327df562&scoped=true&"
import script from "./dragon-activity-statistics.vue?vue&type=script&lang=js&"
export * from "./dragon-activity-statistics.vue?vue&type=script&lang=js&"
import style0 from "./dragon-activity-statistics.vue?vue&type=style&index=0&id=327df562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327df562",
  null
  
)

export default component.exports